import { RoleId } from '@intellio/shared/models';
import { AccountService } from '@intellio/shared/services';
import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';

const disabledFieldTypes = new Set([
  'button',
  'checkbox',
  'file',
  'multicheckbox',
  'radio',
  'select',
]);

type RoleEditableProps = {
  editableRoles?: RoleId[];
  disabled?: boolean;
  readonly?: boolean;
};

type RoleEditableField = FormlyFieldConfig<RoleEditableProps>;

function getEditableRoles(field: RoleEditableField): RoleId[] | undefined {
  let currentField: FormlyFieldConfig | undefined = field;

  while (currentField) {
    const editableRoles = (currentField.props as RoleEditableProps | undefined)
      ?.editableRoles;

    if (editableRoles?.length) {
      return editableRoles;
    }

    currentField = currentField.parent;
  }

  return undefined;
}

export function createRoleEditableExtension(
  accountService: AccountService
): FormlyExtension<RoleEditableField> {
  return {
    prePopulate(field): void {
      const editableRoles = getEditableRoles(field);
      if (!editableRoles || !field.type) {
        return;
      }

      const currentUser = accountService.currentUser;
      const canEdit =
        currentUser?.isExternal === false &&
        currentUser.roles?.some((role) => editableRoles.includes(role.id));

      if (canEdit) {
        return;
      }

      field.props = field.props || {};
      if (
        typeof field.type === 'string' &&
        disabledFieldTypes.has(field.type)
      ) {
        field.props.disabled = true;
      } else {
        field.props.readonly = true;
      }
    },
  };
}
